export const FETCH_ALL_RAISE_AD_REQUEST = "FETCH_ALL_RAISE_AD_REQUEST";
export const GET_ALL_RAISE_REQUEST = "GET_ALL_RAISE_REQUEST";
export const RAISE_NEW_AD_REQUEST = "RAISE_NEW_AD_REQUEST";
export const GET_QUOTATION_DATA = "GET_QUOTATION_DATA";
export const SET_QUOTATION_DATA = "SET_QUOTATION_DATA";
export const POST_QUOTATION_DATA = "POST_QUOTATION_DATA";
export const UPDATE_LAST_STEP_KEY = "UPDATE_LAST_STEP_KEY";
export const GET_AGENCY_QUOTES_DATA = "GET_AGENCY_QUOTES_DATA";
export const ADD_NEW_QUOTE = "ADD_NEW_QUOTE";
export const GET_CITIES = "GET_CITIES";
export const SET_CITIES = "SET_CITIES";
export const SET_AGENCY_QUOTES_DATA = "SET_AGENCY_QUOTES_DATA";
export const DELETE_QUOTE_ROW = "DELETE_QUOTE_ROW";
export const SET_NEW_QUOTE_ROW = "SET_NEW_QUOTE_ROW";
export const SET_AGENCY_QUOTES_ROW_DATA = "SET_AGENCY_QUOTES_ROW_DATA";
export const PATCH_AGENCY_QUOTES = "PATCH_AGENCY_QUOTES";
export const UPADTE_AGENCY_QUOTES = "UPADTE_AGENCY_QUOTES";
export const SAVE_QUOTE_FORM_DATA = "SAVE_QUOTE_FORM_DATA";
export const GET_NOTICE_EMAIL_DATA = "GET_NOTICE_EMAIL_DATA";
export const CREATE_NEW_FOLDER_FOR_AD = "CREATE_NEW_FOLDER_FOR_AD";
export const DELETE_NOTICE_REQUEST = "DELETE_NOTICE_REQUEST";
export const GET_FILES_BY_STAGE = "GET_FILES_BY_STAGE";
export const UPLOAD_REQUEST_FILE = "UPLOAD_REQUEST_FILE";
export const SET_UPLOADED_FILE_FOR_AD_AGENCY =
  "SET_UPLOADED_FILE_FOR_AD_AGENCY";
export const DELETE_UPLOADED_FILE = "DELETE_UPLOADED_FILE";
export const DELETE_UPLOADED_FILE_REDUCER = "DELETE_UPLOADED_FILE_REDUCER";
export const SET_EMAIL_DATA = "SET_EMAIL_DATA";
export const SET_REQUEST_ID = "SET_REQUEST_ID";
export const SEND_EMAIL = "SEND_EMAIL";
export const GET_USER_WORKSPACE_ROLE = "GET_USER_WORKSPACE_ROLE";
export const SET_USER_WORKSPACE_ROLE = "SET_USER_WORKSPACE_ROLE";
export const STOP_REQUEST_LOADING = "STOP_REQUEST_LOADING";
export const START_REQUEST_LOADING = "START_REQUEST_LOADING";
export const UPLOAD_FILE_LOADER_ACTION = "UPLOAD_FILE_LOADER_ACTION";
export const SET_UPLOADED_FILE = "SET_UPLOADED_FILE";
export const RESET_QUOTATION_DATA = "RESET_QUOTATION_DATA";

export type RaiseAdRequestState = {
  userRole: string;
  loading: boolean;
  currentStepKey: string;
  lastStepName: string;
  requestId: string;
  selectedProductId: string;
  states: StatesCitiesType[];
  cities: StatesCitiesType[];
  allRequests: GetAllRaisedRequestType;
  quoationApprovalFormData: QuoationApprovalFormDataType;
  quoteDetailsFormData: QuotationDetailsType;
  adReleaseFile: UploadedFileType[];
  finalMarketFile: UploadedFileType[];
  estimatesProof: UploadedFileType[];
  softCopyProof: UploadedFileType[];
  finalMarketEmailContent: EmailType;
  reviewEmailContent: EmailType;
  isFileUploading: boolean;
};

export type EmailType = {
  to: string;
  cc: string;
  subject: "";
  fixedBody?: "";
  greetings: string;
  message?: string;
  footerMessage: string;
};

export type UploadedFileType = {
  content_type: string;
  created_at: string;
  description: string;
  download_url: string;
  file_category: string;
  file_size: number;
  file_type: string;
  file_url: string;
  id: number;
  modified_at: string;
  original_filename: string;
  request_name: string;
  resource_type: string;
  stage: string;
  title: string;
  uploaded_by: string;
};

export type QuotationDetailsType = {
  data: QuotationFormDataType[];
  folder_created: boolean;
  quote_pricing: any;
  stage: string;
  status: string | null;
  emailContent?: EmailType;
  folder_url?: string;
};

export type QuotationFormDataType = {
  comment?: string;
  created_at: string;
  creative_format: string | null;
  edition: string;
  height: number;
  id: number;
  insertions: number | null;
  issue: string;
  language: string;
  modified_at: string;
  net_cost: number | null;
  publication: string;
  request: number;
  status: string;
  trashed_at: string | null;
  width: null;
  release_date: string | null;
};

export type StatesCitiesType = {
  id: number;
  name: string;
};

export type GetAllRaisedRequestType = {
  count: number;
  next: number | null;
  previous: number | null;
  results: RaisedRequestType[];
};

export type RaisedRequestType = {
  id: number;
  req_id: string;
  request_name: string;
  request_type: string;
  state: string;
  city: string;
  stage: string;
  created_at: string;
  final_release_date: string | null;
  trashed_at: string | null;
  requested_by_name: string;
  metadata?: any;
  branch_code?: string;
  cost_code?: string;
  specific_requirements?: string;
};

export type QuoationApprovalFormDataType = {
  id: number;
  req_id: string;
  branch_code: string;
  city: string;
  otherCity: string;
  cost_code: string;
  created_at: string;
  creative_size: string;
  final_release_date: string;
  length: number;
  metadata: {
    branch_new_address?: string;
    branch_old_address?: string;
    branch_address?: string;
    address?: string;
  };
  request_name: string;
  request_type: string;
  requested_by_name: string;
  specific_requirements: string;
  stage: string;
  state: string;
  trashed_at: string | null;
  width: number;
  workspace_id: string | null;
  otherRequestType: string;
  gl_code: string;
  emailContent: EmailType;
  folder_public_url?: string;
};

export type FetchAllRaiseAdRequestAction = {
  type: typeof FETCH_ALL_RAISE_AD_REQUEST;
  payload: { productId: string; page?: number | string; search?: string };
};

export type GetAllRaisedRequestAction = {
  type: typeof GET_ALL_RAISE_REQUEST;
  payload: { data: any; page: string | number; search?: string };
};

export type RaiseNewRequestAction = {
  type: typeof RAISE_NEW_AD_REQUEST;
  payload: string;
};

export type GetQuotationDataAction = {
  type: typeof GET_QUOTATION_DATA;
  payload: string;
};

export type SetQuotationDataAction = {
  type: typeof SET_QUOTATION_DATA;
  payload: {
    quotationData: QuoationApprovalFormDataType;
    states: StatesCitiesType[];
  };
};

export type PostQuotationDataAction = {
  type: typeof POST_QUOTATION_DATA;
  payload: {
    id: number | string;
    formData: any;
    stage: string;
    nextStepKey: string;
    workspaceId: string;
    emailFormValues?: any;
  };
};

export type UpdateLastStepKey = {
  type: typeof UPDATE_LAST_STEP_KEY;
  payload: string;
};

export type GetAgencyQuotesFormDataAction = {
  type: typeof GET_AGENCY_QUOTES_DATA;
  payload: string;
};

export type SetAgencyQuotesFormDataAction = {
  type: typeof SET_AGENCY_QUOTES_DATA;
  payload: any;
};

export type AddNewQuoteAction = {
  type: typeof ADD_NEW_QUOTE;
  payload: string;
};

export type GetCitiesByStateAction = {
  type: typeof GET_CITIES;
  payload: number;
};

export type SaveQuoteFormDataAction = {
  type: typeof SAVE_QUOTE_FORM_DATA;
  payload: any;
};

export type SetCitiesByStateAction = {
  type: typeof SET_CITIES;
  payload: StatesCitiesType[];
};

export type DeleteQuoteRowAction = {
  type: typeof DELETE_QUOTE_ROW;
  payload: Number;
};

export type SetNewQuoteRow = {
  type: typeof SET_NEW_QUOTE_ROW;
  payload: QuotationFormDataType;
};

export type SetAgencyQuotesRowData = {
  type: typeof SET_AGENCY_QUOTES_ROW_DATA;
  payload: {
    identifier: string | number;
    field: string;
    value: string | number;
  };
};

export type PatchAgencyQuotesAction = {
  type: typeof PATCH_AGENCY_QUOTES;
  payload: {
    status: string;
    stage: string;
    nextStepKey?: string;
    workspaceId?: string;
    id?: number | string;
    folder_url?: string;
    shouldSendMail?: boolean;
    emailContent?: any;
    tableHtml?: any;
  };
};

export type UpdatehAgencyQuotesAction = {
  type: typeof UPADTE_AGENCY_QUOTES;
  payload: {
    quotes_data: QuotationFormDataType[];
    status: string;
    stage: string;
  };
};

export type GetNoticeEmailDataAction = {
  type: typeof GET_NOTICE_EMAIL_DATA;
  payload: { requestId: string | number; stage: number };
};

export type CreateNewFolderForAdOnDAM = {
  type: typeof CREATE_NEW_FOLDER_FOR_AD;
  payload: {
    name: string;
    product_id: string;
    requestId: string;
    shouldSendMail: boolean;
    emailContent: any;
    tableHtml: any;
  };
};

export type DeleteNoticeRequestAction = {
  type: typeof DELETE_NOTICE_REQUEST;
  payload: {
    selectedProductId: string;
    requestId: string;
  };
};

export type GetFilesByStageAction = {
  type: typeof GET_FILES_BY_STAGE;
  payload: {
    stage: string;
    request_id: string;
  };
};

export type UploadRequestFile = {
  type: typeof UPLOAD_REQUEST_FILE;
  payload: {
    request_id: string;
    stage: string;
    file: string;
    original_filename: string;
    title: string;
    file_size: number;
    file_type: string;
    file_category: string;
    selectedProductId: string;
    next_stage: string;
    release_date?: string;
  };
  callback: Function;
};

export type SetUploadedFileForAdAgency = {
  type: typeof SET_UPLOADED_FILE_FOR_AD_AGENCY;
  payload: {
    data: UploadedFileType[];
    stage: string;
  };
};

export type DeleteUploadedFile = {
  type: typeof DELETE_UPLOADED_FILE;
  payload: { id: number; stage: string };
};

export type DeleteUploadedFileReducer = {
  type: typeof DELETE_UPLOADED_FILE_REDUCER;
  payload: { id: number; stage: string };
};

export type SetEmailDataAction = {
  type: typeof SET_EMAIL_DATA;
  payload: {
    data: any;
    stage: number;
  };
};

export type SetRequestId = {
  type: typeof SET_REQUEST_ID;
  payload: {
    requestId: string;
    selectedProductId: string;
  };
};

export type SendEmailAction = {
  type: typeof SEND_EMAIL;
  payload: {
    formData: any;
    template_id: string;
    emailFormValues?: any;
    s3_urls?: string[];
    stage: string;
    tableHtml?: any;
  };
};

export type GetUserWorkspaceRoleAction = {
  type: typeof GET_USER_WORKSPACE_ROLE;
  payload: string;
};

export type SetUserWorkspaceRoleAction = {
  type: typeof SET_USER_WORKSPACE_ROLE;
  payload: string;
};

export interface StopRequestLoadingAction {
  type: typeof STOP_REQUEST_LOADING;
}

export interface StartRequestLoadingAction {
  type: typeof START_REQUEST_LOADING;
}

export type UploadingFileLoaderAction = {
  type: typeof UPLOAD_FILE_LOADER_ACTION;
  payload: boolean;
};

export type SetUploadedFile = {
  type: typeof SET_UPLOADED_FILE;
  payload: any;
};

export type ResetQuoationApprovalFormData = {
  type: typeof RESET_QUOTATION_DATA;
  payload: boolean;
};